<mat-form-field class="app-selector">
  <mat-select [formControl]="appSelectorControl" [placeholder]="placeholderText" [compareWith]="compareApps">
    <mat-option>
      <ngx-mat-select-search [formControl]="appFilterControl" placeholderLabel="Please start typing"
      noEntriesFoundLabel="No Apps found" [searching]="searching()"></ngx-mat-select-search>
    </mat-option>
    @for (app of filteredApps | async; track app.id) {
      <mat-option [value]="app">
        {{app.name}}
      </mat-option>
    }
  </mat-select>
</mat-form-field>
